'use client'

import { AppLink } from '@/shared/lib/router'

import { useFeedStore } from '../../stores/useFeedStore'

import { FEED_FULL_PATH, FEED_PREVIEW_LIMIT } from '@/features/profiles/constants/feed-routes'
import { getFeedItemKey } from '@/features/profiles/types/feed'
import { Button } from '@/shared/ui/Button'
import {
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  CardTitle
} from '@/shared/ui/Card'


import { FeedItem } from './Item'

export const FeedCard = () => {
  const { feed, isEmpty, isSuccess } = useFeedStore()

  if (!isSuccess || isEmpty) return null

  const records = feed ?? []
  const preview = records.slice(0, FEED_PREVIEW_LIMIT)

  return (
    <Card variant="dark">
      <CardHeader>
        <CardTitle>Notificações</CardTitle>
      </CardHeader>
      <CardBody className="flex flex-col gap-2">
        {preview.map(item => (
          <FeedItem
            key={getFeedItemKey(item)}
            item={item}
            showActions={false}
          />
        ))}
      </CardBody>
      <CardFooter>
        <Button as={AppLink} href={FEED_FULL_PATH} className="w-full">
          Ver mais
        </Button>
      </CardFooter>
    </Card>
  )
}
